import {Tabs as TabsBase} from '@yandex-delivery/blocks'
import {useCallback} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {scoped} from '../../utils'
import {TabsProps} from './Tabs.types'

export function Tabs<T extends string | number>({
  name,
  rules,
  defaultValue,
  shouldUnregister,
  onChange: onChangeProp,
  ...tabsProps
}: TabsProps<T>) {
  const {control, watch} = useFormContext()
  const value = watch(name)

  const {
    field: {onChange, onBlur},
  } = useController({
    control,
    name,
    rules,
    defaultValue,
    shouldUnregister,
  })

  const handleChange = useCallback(
    (value: T) => {
      onChange(value)
      onChangeProp?.(value)

      // Без этого вызова стейт формы не учитывал изменения этого инпута,
      // если изменяем после редактирования другого поля формы
      onBlur()
    },
    [onChange, onChangeProp, onBlur],
  )

  return <TabsBase.Segments onChange={handleChange} value={value} {...tabsProps} />
}

export const ScopedTabs = scoped(TabsBase.Segments)
